import styled from 'styled-components';

interface Props {
    backgroundColor: 'default' | 'gray' | 'red' | 'muted';
    textColor: 'text' | 'mutedText';
}

export const BadgeWrapper = styled.div<Props>`
    display: inline-block;
    min-width: 24px;
    min-height: 24px;
    border-radius: 12px;
    border: none;
    box-sizing: border-box;
    padding: 6px;
    margin-left: 4px;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    background: ${props =>
        props.backgroundColor === 'default'
            ? props.theme.root.colors.accent.newBadge
            : props.theme.badge[props.backgroundColor].color};
    color: ${props => props.theme.badge[props.textColor].color};
    font-weight: 500;
`;
